export const handleKeyPress = (event, callback) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/utilities/keyHandler.js